<script>/* eslint-disable */</script>
<template>
    <div>
      <h2>H2 Report</h2>
      <hr>
      <!-- FILTER START -->
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter Option</h4>
        </template>
        <div class="row outerBox filterBox">
            <div class="col row">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="dateTimeInput">From</label>
                  <flat-pickr
                    v-model="filter.start"
                    :config="seperatedRangeConfig"
                    placeholder="Select From Date"
                  />
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="dateTimeInput">To</label>
                  <flat-pickr
                    v-model="filter.end"
                    :config="seperatedRangeConfig"
                    placeholder="Select To Date"
                  />
                </div>
                <div class="col-md-4 row" style="padding-top:26px">
                  <button class="btn btn-primary w-100" type="button" @click="search(0)">
                    <span class="fa fa-filter"></span>&nbsp;&nbsp;Search
                  </button>
                </div>
            </div>
        </div>
      </panel>
      <!-- FILTER END -->

      <b-card class="mb-4">
        <div class="row mb-3">
          <h4 class="col-md-2 col-sm-4 col-10 Aligner-Header ">
            H2 Details By Karesidenan
          </h4>
          <div class="col-md-1"></div>
          <div class="offset-md-7 col-md-2 col-sm-4 col-12 Aligner-Header">
            <button @click="search(1,'/h2-report/by-karesidenan')" class=" btn btn-success w-100" style="max-height:46px"><span class="fa fa-file-excel"/> Export</button>
          </div>
        </div>
        <div class="w-100"  v-if="by_karesidenan"  style="overflow-x:scroll">
          <table class="table text-center">
            <thead>
              <tr style="background-color:black;color:white">
                <th>Region Code</th>
                <th id="qr-registered-region">QR Registered</th>
                <th id="qr-replacement-region">QR Replacement</th>
                <th id="id-customer-region">New ID</th>
                <th id="id-customer-qr-region">Existing ID</th>
                <th id="gr-md-region">H1 to H2</th>
                <th id="gi-md-region">H2 to H2</th>
                <th id="gr-d-region">Service</th>
                <th id="gi-d-region">H12 to H2</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in by_karesidenan" :key="index">
                <td>{{data.karesidenan}}</td>
                <td>{{numberWithCommas(data.qr_register)}}</td>
                <td>{{numberWithCommas(data.qr_replacement)}}</td>
                <td>{{numberWithCommas(data.new_id)}}</td>
                <td>{{numberWithCommas(data.existing_id)}}</td>
                <td>{{numberWithCommas(data.h1_h2)}}</td>
                <td>{{numberWithCommas(data.h2_h2)}}</td>
                <td>{{numberWithCommas(data.service)}}</td>
                <td>{{numberWithCommas(data.h12_h2)}}</td>
              </tr>
              <tr class="bg-grey">
                <th class="text-center" colspan="1">Total</th>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.qr_register)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.qr_replacement)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.new_id)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.existing_id)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.h1_h2)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.h2_h2)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.service)))}}</td>
                <td>{{numberWithCommas(sumArray(by_karesidenan.map(x => x.h12_h2)))}}</td>
              </tr>
          </tbody>
        </table>
        </div>
        
        <div class="text-center w-100" v-else>
          <h5>Loading.......</h5>
        </div>
      </b-card>

      <b-card class="mb-4">
        <div class="row mb-3">
          <h4 class="col-md-2 col-sm-4 col-12 Aligner-Header ">H2 Details By Dealer</h4>
          <div class="col-md-1"></div>
          <div class="offset-md-4 col-md-3 ">
            <Multiselect 
              v-model="filter.karesidenanDealer"
              :options="options.karesidenan.map(type => type.code)"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :allow-empty="true"
              placeholder="All Karesidenan"
            />
          </div>
          <div class="col-md-2 col-sm-4 col-12 Aligner-Header">
            <button @click="search(1,'/h2-report/by-dealer')" class=" btn btn-success w-100" style="max-height:46px"><span class="fa fa-file-excel"/> Export</button>
          </div>
        </div>
        <div class="w-100"  v-if="by_dealer"  style="overflow-x:scroll">
          <table class="table text-center">
            <thead>
              <tr style="background-color:black;color:white">
                <th>Dealer Code</th>
                <th>Dealer Name</th>
                <th :id="header + '-dealer'" v-for="(header, index) in headerTitle" :key="header">
                  {{header}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-grey">
                <th class="text-center" colspan="2">Total</th>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.qr_register)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.qr_replacement)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.new_id)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.existing_id)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.h1_h2)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.h2_h2)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.service)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.h12_h2)))}}</td>
              </tr>
              <tr v-for="(data, index) in showAllData ? by_dealer : by_dealer.length > 20 ? by_dealer.slice(0,20) : by_dealer" :key="index">
                <td>{{data.code}}</td>
                <td>{{data.name}}</td>
                <td>{{numberWithCommas(data.qr_register)}}</td>
                <td>{{numberWithCommas(data.qr_replacement)}}</td>
                <td>{{numberWithCommas(data.new_id)}}</td>
                <td>{{numberWithCommas(data.existing_id)}}</td>
                <td>{{numberWithCommas(data.h1_h2)}}</td>
                <td>{{numberWithCommas(data.h2_h2)}}</td>
                <td>{{numberWithCommas(data.service)}}</td>
                <td>{{numberWithCommas(data.h12_h2)}}</td>
              </tr>
              <tr v-if="by_dealer.length > 20">
                <td colspan="10">
                  <a v-if="!showAllData" class="clickAble" style="color:grey" @click="showAllData = true">Show All</a>
                  <a v-else class="clickAble" style="color:grey" @click="showAllData = false">Hide</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="text-center w-100" v-else>
            <h5>Loading.......</h5>
        </div>
      </b-card>

      <b-card>
        <div class="row mb-3 ">
          <h4 class="col-md-2 col-sm-4 col-12 Aligner-Header ">H2 Details By Month</h4>
          <div class="col-md-1"></div>
          <div class="offset-md-1 col-md-2">
            <Multiselect 
              v-model="filter.karesidenan"
              :options="options.karesidenan.map(type => type.code)"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :allow-empty="true"
              placeholder="All Karesidenan"
            />
          </div>
          <div class="col-md-2 ">
            <Multiselect 
              v-model="filter.city"
              :options="options.city.map(type => type.code)"
              :custom-label="opt => options.city.find(x => x.code == opt).name"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :allow-empty="true"
              placeholder="All Cities"
            />
          </div>
          <div class="col-md-2 ">
            <Multiselect 
              v-model="filter.branch"
              :options="options.dealer.map(type => type.code)"
              :custom-label="opt => options.dealer.find(x => x.code == opt).name"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :allow-empty="true"
              placeholder="All Dealers"
            />
          </div>
          <div class="col-md-2 col-sm-4 col-12 Aligner-Header">
            <button @click="search(1,'/h2-report/by-month')" class=" btn btn-success w-100" style="max-height:46px"><span class="fa fa-file-excel"/> Export</button>
          </div>
        </div>
        
        <div class="w-100"  v-if="by_month"  style="overflow-x:scroll">
          <table class="table text-center">
            <thead>
              <tr style="background-color:black;color:white">
                <th>Month</th>
                <th>Year</th>
                <th :id="header + '-month'" v-for="(header, index) in headerTitle" :key="header">
                    {{header}}
                </th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in by_month" :key="index">
                <td>{{data.bulan}}</td>
                <td>{{data.tahun}}</td>
                <td>{{numberWithCommas(data.qr_register)}}</td>
                <td>{{numberWithCommas(data.qr_replacement)}}</td>
                <td>{{numberWithCommas(data.new_id)}}</td>
                <td>{{numberWithCommas(data.existing_id)}}</td>
                <td>{{numberWithCommas(data.h1_h2)}}</td>
                <td>{{numberWithCommas(data.h2_h2)}}</td>
                <td>{{numberWithCommas(data.service)}}</td>
                <td>{{numberWithCommas(data.h12_h2)}}</td>
                <td><button class="btn btn-primary w-100" @click="getMonthDetail(data.bulan , data.tahun)">Details</button></td>
              </tr>
              <tr class="bg-grey">
                <th class="text-center" colspan="2">Total</th>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.qr_register)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.qr_replacement)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.new_id)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.existing_id)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.h1_h2)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.h2_h2)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.service)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.h12_h2)))}}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="text-center w-100" v-else>
          <h5>Loading.......</h5>
        </div>
      </b-card>

      <detailModal v-on:closeModal="showModal = false" v-if="showModal" :data="summaryData" :period="period"></detailModal>
    </div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Multiselect  from 'vue-multiselect'
import { options } from '@amcharts/amcharts4/core'
import flatPickr from 'vue-flatpickr-component'

import detailModal from './children/detailModal'

export default {
	components: {
        Datepicker,
        Multiselect,
        detailModal,
        flatPickr,
    },
    data () {
      const startOfMonth = moment().startOf('year').toDate();
      const endOfMonth   = moment().toDate();
      return {
        seperatedRangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !this.isRTL(),
        },
        showAllData : false,
        options : this.$store.getters.getFilterOptions,
        filterData: null,
        filter: {
          start: startOfMonth, 
          end: endOfMonth,
          karesidenanDealer: '',
          karesidenan: '',
          city: '',
          branch: ''
          // branch: []
        },
        by_month: [],
        by_karesidenan: [],
        by_dealer: [],
        showModal: false,
        summaryData: null,
        headerTitle : ['QR Registered', 'QR Replacement' , 'New ID' , 'Existing ID' , 'H1 to H2' , 'H2 to H2' , 'Service' , 'H12 to H2']
      }
    },
    mounted () {
        this.loadFilter()
        this.search(0, null)
    },
    watch: {
      'filter.karesidenan' : function () {
        this.search(0 , ['/h2-report/by-month'])

        this.options.city = this.$store.getters.getCityBySingleId(this.filter.karesidenan);
        this.filter.city = '';
      },
      'filter.city' : function () {
        this.search(0 , ['/h2-report/by-month'])

        this.options.dealer = this.$store.getters.getDealerBySingleId(this.filter.karesidenan, this.filter.city);
        this.filter.branch = '';
      },
      'filter.branch' : function () {
        this.search(0 , ['/h2-report/by-month'])
      },
      'filter.karesidenanDealer' : function () {
        this.search(0 , ['/h2-report/by-dealer'])
      }
    },
    methods: {
        sumArray(data) {
          let total = 0

          for(var i = 0;  i < data.length ; i++) {
            total += parseInt(data[i])
          }
          return total
        },
        async getMonthDetail (month , year) {
            let date = moment(`01 ${month} ${year}`)

            let filter = {
                karesidenan : this.filter.karesidenan,
                month : date.month() + 1,
                year : date.year()
            }

            filter = await this.transformFilter(filter)
            filter = await this.initializeFilter(filter)

            let url = "/api/reports/h2-report/daily-detail"
 
            this.$http.get(url + filter)
            .then((resp) => {
                this.summaryData = resp.data.data
                this.showModal = true
                this.period = filter
            })
            .catch((err) => {
                console.log(err)
            })


        },
        loadFilter (type) {
            if (type == 'region'){
                this.filter.branch.length = 0;
                this.filterData.branch = this.$store.getters.getBranch(this.filter.region)
            } else if (type == 'segment'){
                // this.filter.series.length = 0;
                this.filterData.series = this.$store.getters.getSeries(this.filter.segment)

                this.filter.type.length = 0;
                this.filterData.type = this.$store.getters.getType(this.filter.segment, this.filter.series)
            } else if (type == 'series'){
                this.filter.type.length = 0;
                this.filterData.type = this.$store.getters.getType(this.filter.segment, this.filter.series)
            } else {
                this.filterData = this.$store.getters.getFilterOptions
            } 
        },
        async search (flag, url) {
            
            let filter = Object.assign({} , this.filter)
            if(url == null) url = ['/h2-report/by-month', '/h2-report/by-karesidenan', '/h2-report/by-dealer']
            
            if(flag == 1) {
                this.downloadExcel(filter, url)
                return;
            }

            this.loadAPI(filter, url)

        },
        async downloadExcel (filter , url) {
            let variable = url.split('/')[2].split('-').join(' ')

            if(variable == 'by karesidenan') delete filter.karesidenan

            filter = await this.transformFilter(filter)
            filter = await this.initializeFilter(filter)
            filter += '&exportExcel=1'
            
            this.$http.get('/api/reports' + url + filter , {responseType : 'blob'})
            .then((resp)=>{
                const blob = new Blob([resp.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = "H2 report " +  variable;
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        async loadAPI(filter, url) {
            

            for (var i = 0 ; i < url.length ; i++) {
                let obj = Object.assign({} , filter)

                let variable = url[i].split('/')[2].split('-').join('_')

                this[variable] = null;

                if(variable == 'by_karesidenan') {
                  delete obj.karesidenan
                  delete obj.karesidenanDealer
                  delete obj.city
                  delete obj.branch
                } else if(variable == 'by_dealer') {
                  obj.karesidenan = obj.karesidenanDealer
                  delete obj.karesidenanDealer
                  delete obj.city
                  delete obj.branch
                } else {
                  delete obj.karesidenanDealer
                }

                obj = await this.transformFilter(obj)
                obj = await this.initializeFilter(obj)


                this.$http.get('/api/reports' + url[i] + obj)
                .then((resp) => {
                    var data = resp.data.data;
                    this[variable] = (variable == 'by_dealer') ? data.filter(x=>x.code.toLowerCase()!='unknown') : data
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        async initializeFilter (filters) {
            let filterUrl = '?'
            let keys = Object.keys(filters)
            for (var i = 0; i < keys.length; i++) {
              if(filters[keys[i]] && typeof filters[keys[i]] == 'object' && filters[keys[i]].length > 0)
                filterUrl += `${keys[i]}=${filters[keys[i]]}&`
              else if( filters[keys[i]] != null && filters[keys[i]] != ''){
                filterUrl += `${keys[i]}=${filters[keys[i]]}&`
              }
            }
            
            return filterUrl
        },
        async transformFilter (filter) {
            let obj = {}
            let keys = Object.keys(filter)
            for (var i = 0 ; i < keys.length; i++) {
              if(keys[i] == 'start' || keys[i] == 'end')  {
                obj[keys[i]] = moment(filter[keys[i]]).format("YYYY-MM-DD")
              }
              else {
                obj[keys[i]] = filter[keys[i]]
              }
            }
            return obj
        },
        customFormatter : function(date){
			return moment(date).format('Y-MM-DD');
		},
        numberWithCommas(x) {
        return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
}
</script>

<style scoped>
  td .btn {
    line-height: 1;
  }

  .Aligner-Header {
    padding-left:3% !important;
    color: #707070;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .clickAble:hover {
    text-decoration: underline;
    cursor: pointer;
  }
</style>